import { render, staticRenderFns } from "./DialogCostLimit.vue?vue&type=template&id=0dcacd15"
import script from "./DialogCostLimit.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogCostLimit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports